@use '@design/design-tokens/border-radius/border-radius' as *;

.dot {
  width: 8px;
  height: 8px;
  @include border-radius-full;
}
